import { HiX } from 'react-icons/hi';

export default function Modal({ isOpen, onClose, title, children, size = 'md' }) {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '4xl': 'max-w-4xl',
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-primary-500/30 backdrop-blur-sm" onClick={onClose} />
      <div
        className={`
          relative bg-white rounded-2xl shadow-2xl w-full ${sizeClasses[size]}
          animate-[slideUp_0.3s_ease-out] border border-primary-100
        `}
      >
        <div className="flex items-center justify-between p-5 border-b border-primary-100">
          <h3 className="text-lg font-bold text-primary-500">{title}</h3>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg hover:bg-primary-50 transition-colors"
          >
            <HiX className="w-5 h-5 text-primary-300" />
          </button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
